namespace advisorop.components.advisor {

    export class SelectCuInvestorTrustedContactsController {
        investor: domains.IInvestor;
        needInvestorId: boolean = true;

        investorTrustedContact: domains.ITrustedContact = { recordStatus: domains.RecordStatus.NEW };
        investorTrustedContacts: domains.ITrustedContact[] = [];
        removedInvestorTrustedContacts: domains.ITrustedContact[] = [];

        trustedContactsAreDirty: boolean = false;

        dgTrustedContacts: DevExpress.ui.dxDataGridOptions;

        allowChanges: boolean = true;

        states: domains.ILOV[] = [];
        countries: domains.ILOV[] = [];
        relationshipTypes: domains.ILOV[] = [];
        usCountryCode: string = "US";
        selMailingState: domains.ILOV;
        selMailingCountry: domains.ILOV;
        selRelationshipType: domains.ILOV;


        static $inject = ["generalService", "advisorService", "$scope"];
        constructor(private generalService: services.GeneralService, private advisorService: services.AdvisorService, private $scope: ng.IScope) {
            this.dgTrustedContacts = {
                export: {
                    enabled: true,
                    fileName: "InvestorTrustedContacts"
                },
                bindingOptions: {
                    dataSource: "vm.investorTrustedContacts"
                },
                paging: { pageSize: 20 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                noDataText: "No Trusted Contacts added",                
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },                
                wordWrapEnabled: true,
                columns: [
                    { dataField: "id", caption: "Name", alignment: "left", visible: true, cellTemplate: "nameCell" },
                    { dataField: "relTypeStr", caption: "Rel. Type", visible: true },
                    { dataField: "dateOfBirth", caption: "DOB", dataType: "date", format: "shortDate", visible: true },
                    { dataField: "email", caption: "Email", visible: true },
                    { dataField: "contactPhone", caption: "Phone", visible: true },
                    { dataField: "mobilePhone", caption: "Mobile Phone", visible: true },
                    { dataField: "businessPhone", caption: "Business Phone", visible: true },
                    { dataField: "id", caption: "Address", alignment: "left", visible: true, cellTemplate: "address" },
                    { dataField: "id", caption: "#", cellTemplate: "btnActions", width: 100 }
                ],
            };
            this.receiveBroadcast();
        }

        concatArray(items: [string], separator: string): string {
            let retString = "";
            var prependChar: boolean = false;
            for (let item of items) {
                if (item != null) {
                    retString += (prependChar ? separator : "") + item;
                    prependChar = true;
                }
            }
            return retString;
        } 

        $onInit(): void {
            this.loadLovs()
        }

        $onDestroy(): void {
            //console.log("SelectCuInvestorTrustedContacts onDestroy()")
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "investor") {
                    this.investorTrustedContact.investorId = this.investor.id
                    this.loadTrustedContacts()
                }
            }
        }

        addInvestorIdToTrustedContacts(investorId: number) {
            this.investorTrustedContacts = this.investorTrustedContacts.map(tc => {
                tc.investorId = investorId;
                return tc;
            });

            this.removedInvestorTrustedContacts.slice(0, this.removedInvestorTrustedContacts.length);
        }

        receiveBroadcast() {
            let _this = this;
            this.$scope.$on('saveTrustedContacts', function (e, investor) {
                if (_this.needInvestorId) {
                    _this.addInvestorIdToTrustedContacts(investor.id);
                }
                _this.saveChanges();
            });
        }

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {
                    let lovs = data;
                    this.states = lovs.filter(v => v.lovType === domains.LovType.STATES);
                    this.countries = lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 === this.usCountryCode)
                        .concat(lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 !== this.usCountryCode));
                    this.relationshipTypes = lovs.filter(v => v.lovType === domains.LovType.TRUSTED_CONTACT_REL_TYPE);
                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        loadTrustedContacts(): boolean {
            if (this.investor.id > 0) {
                this.advisorService.getTrustedContactsForInvestor(this.investor.id).then(data => {
                    for (var i = 0; i < data.data.length; i++) {
                        if (data.data[i].relationshipType)
                            data.data[i].relTypeStr = this.relationshipTypes.filter(f => f.value == data.data[i].relationshipType)[0].name;
                    }
                    this.investorTrustedContacts = data.data;
                    this.investor.trustedContacts = data.data;
                    return true
                }, (reason) => {
                    toastr.error("Unable to load trusted contacts: ", reason);
                    return false;
                })
            }
            return true;
        }

        validateForm(): boolean {
            return true;
        }

        resetForm(): void {
            this.investorTrustedContact = { recordStatus: domains.RecordStatus.NEW };

            var frm = <ng.IFormController>this.$scope["frmTrustedContact"];
            frm.$setUntouched()
        }

        mailingAddressChanged(): void {
            if (this.selMailingState)
                this.investorTrustedContact.mailingState = this.selMailingState.extra1;
            if (this.selMailingCountry)
                this.investorTrustedContact.mailingCountryId = this.selMailingCountry.extra2;
        }

        relTypeChanged(): void {
            if (this.selRelationshipType) {
                this.investorTrustedContact.relationshipType = this.selRelationshipType.value;
                this.investorTrustedContact.relTypeStr = this.selRelationshipType.name;
            }
        }

        setModel() {
            this.investorTrustedContact.id = 0;
            this.needInvestorId = this.investor.id == null
            this.investorTrustedContact.investorId = this.investor.id;
        }

        addTrustedContact(): void {
            if (this.validateForm()) {      
                //console.log("model to add:", this.investorTrustedContact);
                this.setModel();
                this.investorTrustedContacts.push(this.investorTrustedContact);
                this.trustedContactsAreDirty = true;
                this.resetForm();
            }
        }

        removeTrustedContact(data: domains.ITrustedContact) {
            var index = this.investorTrustedContacts.indexOf(data);

            if (data.id > 0) {
                data.recordStatus = domains.RecordStatus.DELETED;
                this.removedInvestorTrustedContacts.push(data);
            }     
            
            this.investorTrustedContacts.splice(index, 1);
            this.trustedContactsAreDirty = true;
        }

        saveChanges(): void {
            var trustedContactsToSave = this.investorTrustedContacts.concat(this.removedInvestorTrustedContacts);
            //console.log("trustedContactsToSave: ", trustedContactsToSave);

            this.advisorService.saveInvestorTrustedContacts(this.investor.id, trustedContactsToSave).then(data => {
                toastr.success("You have successfuly saved investor trusted contact changes.");
                this.removedInvestorTrustedContacts = [];
                this.loadTrustedContacts();
                this.trustedContactsAreDirty = false;
                }, (reason) => {
                    toastr.error("Unable to save investor trusted contacts: " + reason);
                })
        }
        
    }

    class SelectCuInvestorTrustedContacts implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                investor: "<",
                trustedContactsChanged: "&",
                trustedContactsSave: "&",
                allowChanges:"<"
            };
            this.controller = SelectCuInvestorTrustedContactsController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/select-cu-investor-trusted-contacts.html";
        }
    }
    angular.module(Constants.APP).component("selectCuInvestorTrustedContacts", new SelectCuInvestorTrustedContacts());
}